import { render, staticRenderFns } from "./user-withdrawal-detail.vue?vue&type=template&id=ed9e3f98&"
import script from "./user-withdrawal-detail.vue?vue&type=script&lang=js&"
export * from "./user-withdrawal-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-withdrawal-detail.vue?vue&type=style&index=0&id=ed9e3f98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports